import { render, staticRenderFns } from "./EnrollStudentClass.vue?vue&type=template&id=5fd238e5"
import script from "../../services/student/enroll-student-class.js?vue&type=script&lang=js&external"
export * from "../../services/student/enroll-student-class.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports